import { Router } from "@reach/router";
import React from "react";
import DefaultPage from "./DefaultPage";
import Loadable from "react-loadable";
import Loading from "../Common/Loading";
import Mandate from "./Mandate";

const AsyncSelfDeclaration = Loadable({
  loader: () => import("./SelfDeclaration"),
  loading: () => <Loading></Loading>,
  // delay: 100,
});

const AsyncClientSignup = Loadable({
  loader: () => import("./ClientSignup"),
  loading: () => <Loading></Loading>,
  // delay: 100,
});

const AsyncClientKYC = Loadable({
  loader: () => import("./AadhaarKYC"),
  loading: () => <Loading></Loading>,
  // delay: 100,
});

const AsyncClientFD = Loadable({
  loader: () => import("./FD"),
  loading: () => <Loading></Loading>,
});

const AsyncClientNationalPensionScheme = Loadable({
  loader: () => import("./NationalPensionScheme"),
  loading: () => <Loading></Loading>,
});

const AsyncClientOnboarding = Loadable({
  loader: () => import("./ClientOnboarding"),
  loading: () => <Loading></Loading>,
});
const AsyncActivation = Loadable({
  loader: () => import("./ActivationPage"),
  loading: () => <Loading></Loading>,
});

const TransactionsApproval = Loadable({
  loader: () => import("./TransactionsApproval"),
  loading: () => <Loading></Loading>,
});

const BankProofUpload = Loadable({
  loader: () => import("./BankProofUpload"),
  loading: () => <Loading></Loading>,
});
const AsyncRevenueCalculator = Loadable({
  loader: () => import("./RevenueCalculator"),
  loading: () => <Loading></Loading>,
});
const AsyncJobOpenings = Loadable({
  loader: () => import("./JobOpenings"),
  loading: () => <Loading></Loading>,
});

const AsyncCartPayment = Loadable({
  loader: () => import("./CartPayment"),
  loading: () => <Loading></Loading>
})

const AsyncClientDeclaration = Loadable({
  loader: () => import("./ClientDeclaration"),
  loading: () => <Loading></Loading>
})

const AsyncMandateApproval = Loadable({
  loader: () => import('./Mandate'),
  loading: () => <Loading></Loading>
})

const AsyncInsuranceHealth = Loadable({
  loader: () => import("./HealthInsurance"),
  loading: () => <Loading></Loading>,
});


export default function App() {
  return (
    <Router style={{ display: "flex", height: "100%" }}>
      <DefaultPage default></DefaultPage>
      <AsyncSelfDeclaration path="/self_declaration/*" />
      <AsyncClientSignup path="/client_signup/*" />
      <AsyncClientKYC path="/client_kyc/*" />
      <AsyncClientFD path="/fd/*" />
      <AsyncClientNationalPensionScheme path="/nps/*" />
      <TransactionsApproval path="/transactions/*" />
      <BankProofUpload path="/bankproof/*" />
      <AsyncActivation path="/activation/*" />
      <AsyncClientOnboarding path="/client_onboarding/*" />
      <AsyncRevenueCalculator path="/revenue_calculator" />
      <AsyncJobOpenings path="/job_openings" />
      <AsyncCartPayment path="/cart/*" />
      <AsyncClientDeclaration path="/details_declaration/*" />
      <AsyncMandateApproval path="/mandate/*" />
      <AsyncInsuranceHealth path="/ins_health/*"/>
    </Router>
  );
}
